export const UPDATE_TARGET = {
	STORY_SETTINGS: 'STORY_SETTINGS',
	STORY_ELEMENTS: 'STORY_ELEMENTS',
	CARD_ELEMENTS: 'CARD_ELEMENTS',
	SYMBOL: 'SYMBOL',
} as const;
